import React from "react";
import { Button, Tooltip, Tag, Table } from "antd";
import global from '../../../common/utility/global';

import CustomTable from "../../../components/CustomTable";
const BAJO = 'B';
const ALTO = 'A';
const OPTIMO = 'O';
export default function GeneralTable(props) {



  const renderColor = (row) => {
    if (row.estado.charAt(0) == BAJO)
      return 'red';
    if (row.estado.charAt(0) == ALTO)
      return '#52c41a';
    if (row.estado.charAt(0) == OPTIMO)
      return 'blue';
  };

  return (
    <Table
      className="table-resumen"
      dataSource={props.pagination.dataResumen}
      scroll={{ x: true }}
      size="small"
      style={{ overflowX: "auto" }}
      onChange={(pagination, filters, sorter) => {
        props.onChange({
          page: pagination.current,
          order: sorter.order,
          field: sorter.field
        })
      }}
      pagination={{
        total: props.pagination.total,
        current: props.pagination.page,
        pageSize: props.pagination.pageSize,
        showTotal: (total) => `${total} Registro(s) encontrado(s).`
      }}
      rowKey={(record) => record.id}
      title={() => (
        <div style={{ width: "100%", textAlign: "right" }}>
          <div className="custom-options">
            {props.onExportExcel === undefined ? null : (
              <Button
                ghost
                type="success"
                icon="file-excel"
                onClick={props.onExportExcel}
                style={{ color: "#3fb703" }}
                loading={props.loadingExcel}
              >
                Excel
              </Button>
            )}
          </div>
        </div>
      )}
      columns={[
        {
          title: "Establecimiento",
          dataIndex: "nombreEstablecimiento",
          key: "nombreEstablecimiento",
          sorter: true,
        },
        {
          title: "Almacén",
          dataIndex: "nombreAlmacen",
          key: "nombreAlmacen",
          sorter: true,
        },
        {
          title: "Código de Referencia",
          dataIndex: "codigoReferencia",
          key: "codigoReferencia",
          sorter: true,
        },
        {
          title: "Producto",
          dataIndex: "nombre",
          key: "nombre",
          sorter: true,
        },
        {
          title: "Unidad de Medida",
          dataIndex: "nombreUnidadMedida",
          key: "nombreUnidadMedida",
          sorter: true,
        },

        {
          title: 'Categoria',
          dataIndex: 'categoria',
          key: 'categoria',
          sorter: true
        },
        {
          title: 'Lote',
          dataIndex: 'lote',
          key: 'lote',
          sorter: true
        },
        {
          title: 'Fecha Vencimiento',
          dataIndex: 'fechaVencimiento',
          key: 'fechaVencimiento',
          sorter: true
        },
        {
          title: 'Cantidad Vendida',
          dataIndex: 'cantidad',
          key: 'cantidad',
          sorter: true,
          align: 'right',
          render: (value) => (
            <span>{global.decimalFormat(value.toFixed(3))}</span>
          )
        },
      ]}
    />
  );
}
